import type { TargetMetric } from '@/lib/types';
import type { DrilldownColumn } from '../drilldown-columns-shared';
import { COLLECTED_COLUMNS } from './collected';
import { INVOICED_COLUMNS } from './invoiced';
import { PIPELINE_COLUMNS } from './pipeline';
import { QUOTED_COLUMNS } from './quoted';
import { WON_DEALS_COLUMNS } from './won-deals';

/**
 * The drill-down column list for each target metric (owner 2026-10-28).
 * `booked` and `quoted` both list quotes, so they share one list. The Record
 * keeps this exhaustive: a new TargetMetric fails the typecheck here.
 */
const COLUMNS_BY_METRIC: Record<TargetMetric, DrilldownColumn[]> = {
  pipeline: PIPELINE_COLUMNS,
  quoted: QUOTED_COLUMNS,
  booked: QUOTED_COLUMNS,
  invoiced: INVOICED_COLUMNS,
  collected: COLLECTED_COLUMNS,
  won_deals: WON_DEALS_COLUMNS,
};

export function columnsForMetric(metric: TargetMetric): DrilldownColumn[] {
  return COLUMNS_BY_METRIC[metric];
}

export {
  COLLECTED_COLUMNS,
  INVOICED_COLUMNS,
  PIPELINE_COLUMNS,
  QUOTED_COLUMNS,
  WON_DEALS_COLUMNS,
};
